import classNames from "classnames"
import type {
  MouseEventHandler,
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useCallback,
} from "react"

import styles from "./PopoverMenu.module.scss"
import { usePopoverContext } from "src/floating/Popover"

export interface Props extends ComponentPropsWithoutRef<"button"> {
  autoDismiss?: boolean;
}

export const PopoverMenuItem = forwardRef<HTMLButtonElement, Props>(
  function PopoverMenuItem(props: Props, propRef: Ref<HTMLButtonElement>) {
    const {
      autoDismiss = false,
      ...htmlButtonProps
    } = props

    const { setOpen } = usePopoverContext()

    const className = classNames(
      props.className,
      styles.popoverMenuItem,
    )

    const onClick: MouseEventHandler<HTMLButtonElement> = useCallback(
      (ev) => {
        props.onClick?.(ev)
        if (autoDismiss) {
          setOpen(false)
        }
      },
      [
        setOpen,
        autoDismiss,
        props.onClick,
      ],
    )

    return (
      <button
        {...htmlButtonProps}
        onClick={onClick}
        ref={propRef}
        className={className}
      />
    )
  },
)
